var render = function render() {
  var _vm = this,
      _c = _vm._self._c;

  return !_vm.element.options.hidden ? _c('el-form-item', _vm._b({
    staticClass: "widget-view",
    class: {
      inline: _vm.inline
    },
    style: _vm.itemStyle,
    attrs: {
      "label": _vm.labelText,
      "label-width": _vm.element.options.showLabel === false ? '0' : '',
      "prop": _vm.$attrs.prop
    }
  }, 'el-form-item', _vm.itemProps, false), [_vm._t("item-content", function () {
    return [_vm.componentCls ? _c(_vm.componentCls, _vm._b({
      ref: "control",
      tag: "component",
      attrs: {
        "element": _vm.element,
        "value": _vm.calculatedValue,
        "readonly": _vm.readonly,
        "form-data": _vm.formData
      },
      on: {
        "input": _vm.handleInput
      }
    }, 'component', _vm.element.options, false)) : _vm._e()];
  }), _vm.element.options.tip ? _c('template', {
    slot: "label"
  }, [_c('div', {
    staticClass: "label"
  }, [_vm._v(" " + _vm._s(_vm.labelText) + " ")]), _c('div', {
    staticClass: "control-tip"
  }, [_vm._v(" " + _vm._s(_vm.element.options.tip) + " ")])]) : _vm._e()], 2) : _vm._e();
};

var staticRenderFns = [];
export { render, staticRenderFns };